import {Button, Grid, Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {getHomeInternalUrl, getNodeInternalUrl} from "../../../constants/appRoutes";
import {NodeVisibility} from "../../../model/IHubMinimalNode.d.ts";

const HomeButton = ({noNode, node}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  return (
    <Grid>
      {noNode ? null : node && node?.visible !== NodeVisibility.No ? (
        <Tooltip title={t("components.header.actions.nodeHome.title")}>
          <Button
            variant="text"
            color="inherit"
            onClick={() => navigate(getNodeInternalUrl((node?.code || "").toLowerCase()))}
            aria-label={t("components.header.actions.nodeHome.ariaLabel")}
          >
            {t("components.header.actions.nodeHome.label")}
          </Button>
        </Tooltip>
      ) : (
        <Tooltip title={t("components.header.actions.home.title")}>
          <Button
            variant="text"
            color="inherit"
            onClick={() => navigate(getHomeInternalUrl())}
            aria-label={t("components.header.actions.home.ariaLabel")}
          >
            {t("components.header.actions.home.label")}
          </Button>
        </Tooltip>
      )}
    </Grid>
  );
};

export default HomeButton;
